module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h2', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dedicated to My wife April, my boys, Richard and Nicholas, and all my brothers in The Corps.")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage",
    attrs: {
      "id": "nick"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gunny Sergeant Nick Popaditch with wife April enjoying a night out prior to his deployment in 2004 (Operation Iraqi Freedom 2). “We both knew I was going, but only I knew I had volunteered to go back.”")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Popaditch Family")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c3de0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnceAMarine_dedication.vue
// module id = 66
// module chunks = 0